import { render, staticRenderFns } from "./SubNavigationLeadTabs.vue?vue&type=template&id=45d2a476&"
import script from "./SubNavigationLeadTabs.vue?vue&type=script&lang=ts&"
export * from "./SubNavigationLeadTabs.vue?vue&type=script&lang=ts&"
import style0 from "./SubNavigationLeadTabs.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports